// extracted by mini-css-extract-plugin
export default {"report-frequency-selector":"ReportFrequencySelector_report-frequency-selector__ujQ5y"};